<template>
  <div>
    <h1 class="title">Progressi Brand Ambassador</h1>

    <div class="container">
      <h2 class="subtitle">Visite</h2>
      <div class="columns is-mobile">
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">Totale</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="stats.cards.positive === null"
                ></b-icon>
                <span v-else>{{ stats.cards.positive + stats.cards.negative }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">Positive</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="stats.cards.positive === null"
                ></b-icon>
                <span v-else>{{ stats.cards.positive }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">Negative</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="stats.cards.negative === null"
                ></b-icon>
                <span v-else>{{ stats.cards.negative }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 class="subtitle">Visite uniche</h2>
      <div class="columns is-mobile">
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">Totale visite uniche</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="stats.locations.total === null"
                ></b-icon>
                <span v-else>{{ stats.locations.total }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">PV con TO</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="stats.locations.positive === null"
                ></b-icon>
                <span v-else>{{ stats.locations.positive }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">Visite negative uniche</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="stats.locations.negative === null"
                ></b-icon>
                <span v-else>{{ stats.locations.negative }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 class="subtitle">Totale volumi</h2>
      <div class="columns is-mobile">
        <!-- N -->
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">N</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="quantities[1] == null"
                ></b-icon>
                <span v-else>{{ quantities[1].total }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- LITRI -->
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">LITRI</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="quantities[2] == null"
                ></b-icon>
                <span v-else>{{ quantities[2].total / 1000 }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- CHILOGRAMMI -->
        <div class="column">
          <div class="level-item has-text-centered">
            <div class="box">
              <div class="heading">KG</div>
              <div class="title">
                <b-icon
                  pack="fas"
                  icon="circle-notch"
                  custom-class="fa-spin"
                  size="is-small"
                  v-if="quantities[3] == null"
                ></b-icon>
                <span v-else>{{ quantities[3].total / 1000 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      stats: {
        cards: { positive: null, negative: null },
        locations: { total: null, positive: null, negative: null }
      },
      quantities: {}
    };
  },
  methods: {},
  computed: {
    productsUm() {
      return this.$ajax.getObject("productsUm");
    }
  },
  mounted() {
    this.$ajax.request({
      address: `/stats/${this.$route.params.id |
        this.$ajax.getUser().id}/orders`,
      method: "GET",
      onSuccess: response => {
        this.stats = response.data;
      }
    });

    [1, 2, 3].forEach(id => {
      // request quantities|volumes
      this.$ajax.request({
        address: `/stats/${this.$route.params.id |
          this.$ajax.getUser().id}/${id}/quantities`,
        method: "GET",
        silent: true,
        onSuccess: response => {
          Vue.set(this.quantities, response.data.id, response.data);
        }
      });
    });
  }
};
</script>
